// extracted by mini-css-extract-plugin
export default {"lowerNavBar":"BottomNav_lowerNavBar__Dtfts","lowerNavBar_inner":"BottomNav_lowerNavBar_inner__oPAjq","active":"BottomNav_active__vA+yk"};